import { Card, Typography, Row, Col, Image, Divider } from "antd";
import axios from "axios";
import SanitizeHTML from "components/SanitizeHTML/SanitizeHTML";
import { useEffect, useState } from "react";
import { Article } from "interfaces/websiteContent";
import { useParams } from "react-router-dom";
import useViewport from "components/UseViewport/UseViewport";
import fallback from "assets/images/fallbackImg.png";
import ArticleCards from "containers/FrontPage/NewsSection/ArticleCards/ArticleCards";

const { Title, Text } = Typography;

const SingleArticle = () => {
  const { width } = useViewport();
  const breakpoint = 992;

  const [article, setArticle] = useState<Article>();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    axios.get<Article>(`/website-contents/articles/${id}/`).then(response => {
      setArticle(response.data);
    });
  }, [id]);

  if (!article) {
    return null;
  }

  const published = new Date(article.created_at).toLocaleDateString("no-nb", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const updated = new Date(article.updated_at).toLocaleDateString("no-nb", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      <Card
        style={
          width < breakpoint
            ? { width: "95%", margin: "auto", marginTop: "5%" }
            : { width: "80%", margin: "auto", marginTop: "5%" }
        }
      >
        <Row gutter={[20, 5]}>
          <Col>
            <Title level={2}>{article.title}</Title>
          </Col>
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 24, order: 1 }}
            lg={{ span: 24, order: 1 }}
          >
            <Divider />
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 12, order: 1 }}
            lg={{ span: 12, order: 1 }}
          >
            <Image
              preview={false}
              width="100%"
              src={article.big_image}
              onError={e => {
                e.currentTarget.src = fallback;
              }}
              style={{ borderRadius: "var(--border-radius)", width: "100% !important" }}
            />
          </Col>
          <Col
            xs={{ span: 24, order: 3 }}
            sm={{ span: 24, order: 3 }}
            md={{ span: 12, order: 1 }}
            lg={{ span: 12, order: 1 }}
          >
            <Col span={24}>
              <Text italic>Publisert: {published}</Text>
            </Col>
            <Col>
              <Text italic>Sist endret: {updated}</Text>
            </Col>
            <Divider />
            <Col>
              <SanitizeHTML html={article.content} />
            </Col>
          </Col>
        </Row>
      </Card>

      <Row
        style={
          width < breakpoint
            ? { width: "95%", margin: "auto", marginTop: "5%" }
            : { width: "90%", margin: "auto", marginTop: "5%" }
        }
      >
        <Divider />
        <Col span={24}>
          <Title level={2} style={{ width: "95%", margin: "", marginBottom: "0" }}>
            Andre nyheter
          </Title>
        </Col>
        <Col span={24}>
          <Row justify="center" gutter={[30, 0]}>
            <ArticleCards currentArticleId={article.id} />
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default SingleArticle;
